import GetUnlimiterIcon from '../Icons/GetUnlimiterIcon';
import clsx from 'clsx';
import React from 'react';

interface IGetUnlimited {
  variant: 'sideBar' | 'page' | 'dark';
  upgradeModal: (params: boolean) => void;
}
export default function GetUnlimited({ variant, upgradeModal }: IGetUnlimited) {
  return (
    <div
      className={clsx(
        'rounded-6 p-3',
        variant === 'sideBar' ? 'bg-white text-primary' : null,
        variant === 'page' ? 'bg-white text-primary shadow-xs' : null,
        variant === 'dark' ? 'bg-primary text-white' : null
      )}
    >
      <button
        type={'button'}
        className={
          'flex items-center text-white justify-center gap-2 w-full mb-3 h-10 px-3 py-2.5 font-semibold max-mobile:text-12 uppercase rounded-6 bg-gradient-to-r from-[#D13A0A] to-[#FFA901]'
        }
        onClick={() => upgradeModal(true)}
      >
        <GetUnlimiterIcon />
        Get Unlimited
      </button>
      <p
        className={
          'text-13 max-mobile:text-12 max-mobile:max-w-[290px] mx-auto leading-176 font-semibold text-center'
        }
      >
        Upgrade to an Unlimited account to enable Rumble branding!
      </p>
    </div>
  );
}
